import { render } from "./baobeiOrderManage.vue?vue&type=template&id=2793ea14"
import script from "./baobeiOrderManage.vue?vue&type=script&lang=js"
export * from "./baobeiOrderManage.vue?vue&type=script&lang=js"

import "./baobeiOrderManage.vue?vue&type=style&index=0&id=2793ea14&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__